<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
    >
      <!-- <el-form-item label="选择车型:" prop="inputList">
        <carSearch
          @increment="appAddCounter"
          :inputList.sync="row"
          :searchType="3"
        ></carSearch>
      </el-form-item>
      <el-form-item label="优惠成交价:" prop="special_price_true">
        <el-input v-model="form.special_price_true"></el-input>
      </el-form-item>
      <el-form-item label="降价幅度:" prop="special_discount_max">
        <el-input v-model="form.special_discount_max"></el-input>
      </el-form-item>
      <el-form-item label="车源类型:" prop="special_case">
        <el-input v-model="form.special_case"></el-input>
      </el-form-item>
      <el-form-item label="手续:" prop="special_procedure">
        <el-input v-model="form.special_procedure"></el-input>
      </el-form-item>
      <el-form-item label="销售人员:" prop="userid">
        <el-select
          v-model="form.userid"
          filterable
          placeholder="销售人员"
        >
          <el-option
            v-for="item in saleList"
            :key="item.id"
            :label="item.username"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="车源所在地:" prop="cityid">
        <el-select
          v-model="form.cityid"
          filterable
          placeholder="车源所在地"
        >
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车型颜色:" prop="special_color">
        <el-input v-model="form.special_color"></el-input>
      </el-form-item>
      <el-form-item label="排序:" prop="sort">
        <el-input v-model="form.sort" placeholder="0在前面正序排列" type="number"></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input v-model="form.remark"></el-input>
      </el-form-item> -->
      
      <div class="P_border" v-if="replaceData.length > 0">
        <div class="P_tit">现有同款车型</div>
        <el-table border :data="replaceData">
          <!-- <el-table-column fixed type="selection" width="55">
          </el-table-column>
          <el-table-column
            type="index"
            fixed
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            label="销售名称"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.username:'暂未设置'}}</template>
          </el-table-column>
          <el-table-column
            prop="get_brand.brand_name"
            label="品牌名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_series.series_name"
            label="车系名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_model.model_name"
            label="车型名称"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="special_price_true"
            align="center"
            label="优惠成交价"
          >
          </el-table-column>
          <el-table-column
            prop="special_discount_max"
            align="center"
            label="降价幅度"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="special_case"
            align="center"
            label="车源类型"
          >
          </el-table-column> -->
          <el-table-column
            prop="cityid"
            align="center"
            label="车源所在地"
          >
            <template slot-scope="scope">{{scope.row.get_city?scope.row.get_city.name:'暂无设置'}}</template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            label="销售电话"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.phone:'暂未设置'}}</template>
          </el-table-column> -->
          <!-- <el-table-column prop="created_at" align="center" label="时间">
            <template slot-scope="scope">{{$utils.isDate(scope.row.created_at)}}</template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="sort"
            align="center"
            label="排序"
          >
          </el-table-column> -->
          <!-- <el-table-column
            prop="address"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="onAudit(scope.row)"
                type="primary" 
                plain
                >审核</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <div class="P_tit" style="color: #FF0000;margin: 10px 0;">新的车型</div>
        <el-table border :data="newData">
          <!-- <el-table-column fixed type="selection" width="55">
          </el-table-column>
          <el-table-column
            type="index"
            fixed
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            label="销售名称"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.username:'暂未设置'}}</template>
          </el-table-column>
          <el-table-column
            prop="get_brand.brand_name"
            label="品牌名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_series.series_name"
            label="车系名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_model.model_name"
            label="车型名称"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="special_price_true"
            align="center"
            label="优惠成交价"
          >
          </el-table-column>
          <el-table-column
            prop="special_discount_max"
            align="center"
            label="降价幅度"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="special_case"
            align="center"
            label="车源类型"
          >
          </el-table-column> -->
          <el-table-column
            prop="cityid"
            align="center"
            label="车源所在地"
          >
            <template slot-scope="scope">{{scope.row.get_city?scope.row.get_city.name:'暂无设置'}}</template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            label="销售电话"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.phone:'暂未设置'}}</template>
          </el-table-column> -->
          <!-- <el-table-column prop="created_at" align="center" label="时间">
            <template slot-scope="scope">{{$utils.isDate(scope.row.created_at)}}</template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="sort"
            align="center"
            label="排序"
          >
          </el-table-column> -->
          <!-- <el-table-column
            prop="address"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="onAudit(scope.row)"
                type="primary" 
                plain
                >审核</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <el-form-item label="审核意见" prop="audit_type">
        <el-select v-model="form.audit_type" placeholder="请选择审核意见" style="width: 50%;">
          <el-option
            v-for="item,key in [
                  { value: 0, label: '待审核' },
                  { value: 1, label: '审核新增' },
                  { value: 2, label: '审核驳回' },
                  { value: 3, label: '审核替换' },
                  { value: 4, label: '审核已替换' },
                ]"
            :key="key"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="审核说明" prop="audit_content">
        <el-input v-model="form.audit_content" type="textarea" placeholder="审核说明" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        <el-button @click="close(2)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getUserList,
  car_city,
  car_special_offer_search
} from "../../api/api";
import carSearch from "../../components/car-search/car-search";
export default {
  name: "car-special-offer-form",
  components: {
    carSearch,
  },
  props: {
    layerid: String,
    edit: Boolean,
    seriesid: Number,
    row: {
      default: function () {
        return [];
      },
    },
  },
  data() {
    let data = {
      form: {
        cityid: "",
        brandid: "",
        seriesid: "",
        modelid: "",
        sale: "", // 销售人员
      },
      loading: false,
      rules: {
        audit_type: [
          { required: true, message: '请选择审核意见', trigger: 'change' }
        ],
        audit_content: [
          { required: true, message: '请填写审核说明', trigger: 'blur' }
        ]
      },
      options: [],
      inputList: [],
      saleList: [], // 销售人员
      cityList: [], // 城市列表
      replaceData: [],
      newData: [],
    };
    return data;
  },
  async mounted() {
    if (this.seriesid) this.form.seriesid = this.seriesid;
    if (this.edit) {
      // console.log("this.row",this.row)
      let msg = await car_special_offer_search({
        modelid: this.row.modelid,
        audit_type: 1
      });
      let {data} = msg;
      data = JSON.parse(data).data;
      if(data){
        this.replaceData.push(data)
        this.newData.push(this.row)
      }
      // this.form = data;
      console.log("编辑数据",data)
      this.form = this.row
    }
    this.getList();
    this.car_city();
  },
  methods: {
    car_city(){
      car_city().then((msg)=>{
        let { data } = msg;
        data = JSON.parse(data).data.data;
        this.cityList = data;
        console.log("msg",data);
      })
    },
    getList() {
      getUserList().then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.saleList = data;
      });
    },
    onSubmit(e) {
      this.form.type = 1; //手动上传数据
      let data = this.form;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit("emincarofer",{form:data})
        } else {
          this.$message.error("请检查表单完整性");
          return false;
        }
      });
    },
    close() {
      this.$emit("emincarofer",{})
    },
    appAddCounter: function (e) {
      console.log("子组件传的值：",e);
      this.form.brandid = e["brandid"];
      if (e["seriesid"])
        this.form.seriesid = e["seriesid"] ? e["seriesid"] : "";
      if (e["modelid"]) this.form.modelid = e["modelid"] ? e["modelid"] : "";
    }
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
.mar10{
  margin-right: 10px;
  font-weight: bold;
  span{
    color: #2e2c2c;
  }
}
.P_border{
  border: 1px solid #f1f1f1;
  padding: 5px 10px;
  margin-bottom: 10px;
  .P_tit{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #f1f1f1;
  }
  .P_flex{
    display: flex;
  }
}
</style>
<style>
.el-cascader--small {
  width: 100% !important;
}
</style>
